var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"app":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.backTo}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5672c93e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/ToolBar.vue
// module id = 1455
// module chunks = 1